// src/components/Header/Nav/index.tsx
"use client"

import type React from "react"
import clsx from "clsx"
import type { Header as HeaderType } from '@/payload-types'
import { CMSLink } from "@/components/Link"
import Link from "next/link"
import { MegaMenu } from "./MegaMenu"
import { Search } from "lucide-react"

type LinkBlock = { blockType: "linkItem"; link: any }
type MegaMenuBlock = {
  blockType: "megaMenu"
  label: string
  columns?: Array<{ heading?: string; items?: Array<{ link: any }> }>
}

export const HeaderNav: React.FC<{
  data: HeaderType
  className?: string
  onMegaMenuToggle?: (isOpen: boolean) => void
  isMegaMenuOpen?: boolean
}> = ({ data, className, onMegaMenuToggle, isMegaMenuOpen }) => {
  const blocks = (data as any)?.navItems ?? []

  return (
    <nav className={clsx("flex items-center gap-6", className)}>
      {/* ✅ put the items back */}
      {blocks.map((block: LinkBlock | MegaMenuBlock, i: number) => {
        if (block.blockType === "linkItem") {
          return <CMSLink key={i} {...(block as LinkBlock).link} appearance="link" />
        }
        if (block.blockType === "megaMenu") {
          return <MegaMenu key={i} block={block as MegaMenuBlock} onToggle={onMegaMenuToggle} />
        }
        return null
      })}

      {/* Search + Donate (desktop) */}
      <Link
        href="/search"
        aria-label="Search"
        className={clsx(
          "ml-4 -mr-2 h-10 w-10 aspect-square shrink-0 rounded-full flex items-center justify-center transition-colors focus:outline-none",
          isMegaMenuOpen
            ? "border-2 border-minigreen-2 text-mini-primary dark:text-mini-white/80 bg-transparent hover:bg-minigreen-2/10"
            : "border-2 border-minigreen-7/80 text-mini-black/80 dark:text-mini-white/80 bg-transparent hover:bg-minigreen-7/10 dark:border-minigreen-2  dark:hover:bg-minigreen-2/10"
        )}
      >
        <Search size={18} strokeWidth={3} className={clsx("", isMegaMenuOpen ? "text-white" : "")} />
      </Link>

      <Link
        id="header-donate-button"
        href="https://secure.qgiv.com/for/mininaturereserve"
        target="_blank"
        rel="noopener noreferrer"
        className={clsx(
          "rounded-full px-4 py-2 font-semibold transition tracking-wide font-sans",
          isMegaMenuOpen
            ? "bg-minigreen-2 hover:bg-minigreen-1 text-mini-primary"
            : "bg-minigreen-7 hover:bg-minigreen-6 text-white dark:bg-minigreen-2 dark:hover:bg-minigreen-3 dark:text-mini-primary"
        )}
      >
        DONATE
      </Link>
    </nav>
  )
}
